// src/extenders/product-recommendations.js
var ProductRecommendations = class extends HTMLElement {
  constructor() {
    super();
    const productRecommendationsSection = this;
    const elements = this.querySelectorAll(".swiper-slide");
    const cartDrawerElement = document.querySelector("cart-drawer");
    const handleSection = () => {
      const url = productRecommendationsSection.dataset.url;
      const arraySize = elements.length;
      if (arraySize === 0) {
        fetch(url).then((response) => response.text()).then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector(".product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
          const recommendationsSlider = productRecommendationsSection.querySelector("recommendations-slider");
          if (cartDrawerElement.getAttribute("aria-hidden") === "false" && recommendationsSlider) {
            const desktopRecommendations = document.querySelector("#desktop-recommendations");
            desktopRecommendations.setAttribute("aria-hidden", "false");
            desktopRecommendations.style.visibility = "visible";
          }
        }).catch((e) => {
          console.error(e);
        });
      }
    };
    handleSection();
  }
};
if (!customElements.get("product-recommendations")) {
  customElements.define("product-recommendations", ProductRecommendations);
}
